import { useBookingActivityContext } from "PFApp/booking/parts/providers/booking_activity_context_provider";
import { TemplateKey } from "PFApp/constants/templates";
import { useTemplate } from "PFApp/hooks";
import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import { activityPermissions } from "PFCore/helpers/templates";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import useBookingCategories from "PFCore/hooks/use_booking_categories";

export const useShouldDisplayEngagementSelect = () => {
  const {
    data: { templates, permissionsGroup }
  } = useMyAccountInfo();
  const { isEnabled: isBMEnabled, canCreateEngagementBookings } = useBookingModulePermissions();
  const { activity } = useBookingActivityContext();
  const engagementTemplate = useTemplate(TemplateKey.Engagement);
  const activityTemplate = useTemplate(activity?.template_id);

  const isActivityEngagement = activityTemplate?.key === "engagement";
  const isLinkingToEngagementEnabled = engagementTemplate && engagementTemplate.bookings_allowed;
  const engagementMatchesPermissions = ["ro", "rw"].includes(
    activityPermissions(permissionsGroup, templates, "engagement") ?? ""
  );

  const { checkWriteAccessToAtLeastOneCategory } = useBookingCategories();
  const hasWriteAccessToAtLeastOneDemandCategory = checkWriteAccessToAtLeastOneCategory({
    demandRelated: true
  });

  return (
    isBMEnabled &&
    canCreateEngagementBookings &&
    !!isLinkingToEngagementEnabled &&
    (!activity || isActivityEngagement) &&
    engagementMatchesPermissions &&
    hasWriteAccessToAtLeastOneDemandCategory
  );
};
